import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditIdentityProviderRequestFailure({ uuid }) {
      const req = getState().find(
        ({ identityProvider }) => identityProvider.uuid === uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isEditIdentityProviderRequestPending({ uuid }) {
      const req = getState().find(
        ({ identityProvider }) => identityProvider.uuid === uuid,
      );

      return req ? req.request.isPending : false;
    },
    isEditIdentityProviderRequestSuccess({ uuid }) {
      const req = getState().find(
        ({ identityProvider }) => identityProvider.uuid === uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
